import { format } from 'date-fns';

export const DateHelper = () => {
  const formatDate = (dateString: string): string => {
    return format(new Date(dateString), 'dd.MM.yyyy');
  };

  const formatHour = (dateString: string): string => {
    return format(new Date(dateString), 'HH:mm');
  };

  return {
    formatDate,
    formatHour,
  };
};
